export default [
	
	{
		slug: "intro",
		trigger: "on-start-game",
		steps: [
			{
				fr: "Prêt(e) gamin(e) ?<br>Ton objectif est de parcourir ce monde pour éliminer le boss final.<br>Facile hein ?",
				en: "Ready kid?<br>Your goal is to travel the world to eliminate the final boss.<br>Easy huh?",
			},
			{
				fr: "Pour cela, tu vas devoir poser des cartes sur les emplacements libres du terrain de jeu. Après quoi, ton personnage se déplacera automatiquement.",
				en: "To do so, you'll have to put cards on the free spaces on the board. After that, your character will move automatically.",
			},
			{
				fr: "Durant ton aventure, tu vas rencontrer des ennemis sur ta route qu'il faudra vaincre pour continuer.",
				en: "During your journey, you will meet enemies on your way that you will have to defeat to continue.",
				highlight: ".board-card-content .sprite .img"
			},
			{
				fr: "Comme tu le vois, les cartes ont une valeur (en haut à gauche) associée à un effet.",
				en: "As you can see, the cards have a value (top left) associated with an effect.",
				highlight: ".hand .cards"
			},
			{
				fr: "Par exemple, la valeur des cartes armes s'ajoute à ton attaque de base. Celle des cartes boucliers te confère de l'armure permettant d'encaisser des dégâts.",
				en: "For example, the value of the weapon cards adds to your basic attack. Shield cards give you armor to take damage.",
				highlight: ".hand .cards"
			},
			{
				fr: "Lorsque ton personnage se déplace sur une arme ou un bouclier, il l'équipe automatiquement. Cool hein ?<br>Attention toutefois car il ne dispose que de 2 emplacements !",
				en: "When your character moves on a weapon or a shield, it automatically equips it. Cool huh?<br>Be careful though as there are only two slots available!",
				highlight: ".equipments"
			},
			{
				fr: "Par ailleurs, les armes ou boucliers disposent d'une durabilité visible par les points en haut de la carte. Une fois épuisée, l'équipement est détruit !<br>Fais attention à ne pas combattre sans équipement, c'est risqué.",
				en: "Moreover, the weapons or shields have a durability visible by the dots at the top of the card. Once exhausted, the equipment is destroyed!<br>Be careful not to fight without equipment, it's risky.",
				highlight: ".hand .card .durability"
			},
			{
				fr: "Allez gamin(e), à toi de jouer maintenant !<br>Joue des cartes et appuie sur go!",
				en: "Come on kid, it's your turn now!<br>Play some cards and press go!",
			},
			
		]
	},

]